import { useEffect, useState } from "react";
import { translationSettingsStore, alimSessionValid } from "../../stores/sessionStore";
import Axios from 'axios';

const TranslationMenu=()=>{
    const [translationSettings, setTranslationSettings] = useState(() => {
        const savedSettings = JSON.parse(localStorage.getItem("translationSettings"));
        return savedSettings || {
          translit: true,
          asdTranslate: true,
          malikTranslate: true,
          mustafaTranslate: true,
          piktcalTranslate: true,
          yusufTranslate: true,
        };
    });

    const [isInitiated,setIsInitiated]=useState(false);

    const checkAllTranslationStatus = () => {
        // Exclude 'translit' and check if all other translations are false
        const settingsToCheck = Object.entries(translationSettings).filter(([key]) => key !== 'translit');
        
        // Check if all translation settings (excluding 'translit') are false
        const allTranslationsFalse = settingsToCheck.every(([key, value]) => value === false);

        if (allTranslationsFalse) {
            // If all are false (excluding 'translit'), execute the true part
            const cards = document.querySelectorAll('.emptyMessage');
            cards.forEach((item) => {
                item.classList.remove('hidden');
            });
        } else {
            // If not all are false (excluding 'translit'), execute the false part
            const cards = document.querySelectorAll('.emptyMessage');
            cards.forEach((item) => {
                item.classList.add('hidden');
            });
        }
    };

    const toggleTranslationPageCards=(cardType,toggleState)=>{
        // Update the cards' visibility based on the new transliteration state
        const cards = document.querySelectorAll(`.${cardType}`);
        cards.forEach((item) => {
            if (toggleState) {
                item.classList.remove('hidden');
            } else {
                item.classList.add('hidden');
            }
        });
        setIsInitiated(true);
    }

    const initTranslationCards=()=>{
        const savedSettings = JSON.parse(localStorage.getItem("translationSettings"));
        if((location.pathname.includes(`/kids-quran/`)||savedSettings===null)&&!isInitiated)
        {
            toggleTranslationPageCards('ayahTranslit',translationSettings.translit);
            toggleTranslationPageCards('ayahTransation1',translationSettings.asdTranslate);
            toggleTranslationPageCards('ayahTransation2',translationSettings.malikTranslate);
            toggleTranslationPageCards('ayahTransation3',translationSettings.mustafaTranslate);
            toggleTranslationPageCards('ayahTransation4',translationSettings.piktcalTranslate);
            toggleTranslationPageCards('ayahTransation5',translationSettings.yusufTranslate);
        }

        if(savedSettings===null)
        {
            const translationTempSettins={
                translit:true,
                asdTranslate:true,
                malikTranslate:true,
                mustafaTranslate:true,
                piktcalTranslate:true,
                yusufTranslate:true
            }
            localStorage.setItem('translationSettings',JSON.stringify(translationTempSettins));
        }
    }

    const toggleTransliteration = () => {
        // Get the current translation settings from the React state (not localStorage directly)
        const newTransliterationState = !translationSettings.translit; // Toggle the translit state
        
        toggleTranslationPageCards('ayahTranslit',newTransliterationState);
    
        // Update the translationSettings state with the new translit state
        setTranslationSettings((prevSettings) => {
            const updatedSettings = { ...prevSettings, translit: newTransliterationState };
            // Save the updated settings to localStorage
            localStorage.setItem('translationSettings', JSON.stringify(updatedSettings));
            return updatedSettings;
        });
    };    

    const toggleAsdTranslate=()=>{
        // Get the current translation settings from the React state (not localStorage directly)
        const newTransliterationState = !translationSettings.asdTranslate; // Toggle the translit state

        toggleTranslationPageCards('ayahTransation1',newTransliterationState);
    
        // Update the translationSettings state with the new translit state
        setTranslationSettings((prevSettings) => {
            const updatedSettings = { ...prevSettings, asdTranslate: newTransliterationState };
            // Save the updated settings to localStorage
            localStorage.setItem('translationSettings', JSON.stringify(updatedSettings));
            return updatedSettings;
        });
    }

    const toggleMalTranslate=()=>{
        // Get the current translation settings from the React state (not localStorage directly)
        const newTransliterationState = !translationSettings.malikTranslate; // Toggle the translit state

        toggleTranslationPageCards('ayahTransation2',newTransliterationState);
    
        // Update the translationSettings state with the new translit state
        setTranslationSettings((prevSettings) => {
            const updatedSettings = { ...prevSettings, malikTranslate: newTransliterationState };
            // Save the updated settings to localStorage
            localStorage.setItem('translationSettings', JSON.stringify(updatedSettings));
            return updatedSettings;
        });
    }

    const toggleMktTranslate=()=>{
        // Get the current translation settings from the React state (not localStorage directly)
        const newTransliterationState = !translationSettings.mustafaTranslate; // Toggle the translit state

        toggleTranslationPageCards('ayahTransation3',newTransliterationState);
    
        // Update the translationSettings state with the new translit state
        setTranslationSettings((prevSettings) => {
            const updatedSettings = { ...prevSettings, mustafaTranslate: newTransliterationState };
            // Save the updated settings to localStorage
            localStorage.setItem('translationSettings', JSON.stringify(updatedSettings));
            return updatedSettings;
        });
    }
    
    const togglePikTranslate=()=>{
        // Get the current translation settings from the React state (not localStorage directly)
        const newTransliterationState = !translationSettings.piktcalTranslate; // Toggle the translit state

        toggleTranslationPageCards('ayahTransation4',newTransliterationState);
    
        // Update the translationSettings state with the new translit state
        setTranslationSettings((prevSettings) => {
            const updatedSettings = { ...prevSettings, piktcalTranslate: newTransliterationState };
            // Save the updated settings to localStorage
            localStorage.setItem('translationSettings', JSON.stringify(updatedSettings));
            return updatedSettings;
        });
    }

    const toggleYatTranslate=()=>{
        // Get the current translation settings from the React state (not localStorage directly)
        const newTransliterationState = !translationSettings.yusufTranslate; // Toggle the translit state

        toggleTranslationPageCards('ayahTransation5',newTransliterationState);
    
        // Update the translationSettings state with the new translit state
        setTranslationSettings((prevSettings) => {
            const updatedSettings = { ...prevSettings, yusufTranslate: newTransliterationState };
            // Save the updated settings to localStorage
            localStorage.setItem('translationSettings', JSON.stringify(updatedSettings));
            return updatedSettings;
        });
    }

    const updateCloudTransSettings = () => {
        const alimWebToken = localStorage.getItem('alim-login-token');
        const fontSettings=JSON.parse(localStorage.fontSettings);
        const colorSchemesettings=localStorage.theme;
        if (alimSessionValid && alimWebToken !== null) {
            const reqData = {
                reciter:localStorage.reciterSettings,
                arb_font:fontSettings.arabicFont,
                eng_font:fontSettings.englishFont,
                eng_font_size:fontSettings.englishFontSize,
                arb_font_size:fontSettings.arabicFontSize,
                asd_settings:translationSettings.asdTranslate,
                mal_settings:translationSettings.malikTranslate,
                mkt_settings:translationSettings.mustafaTranslate,
                pik_settings:translationSettings.piktcalTranslate,
                yat_settings:translationSettings.yusufTranslate,
                transliteration_settings:translationSettings.translit,
                color_scheme:colorSchemesettings
            };
    
            Axios.post(`${alimAPIBaseURI}rpc/sync_user_settings`, reqData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${alimWebToken}`,
                },
            })
            .then(response => {
                console.log(response.data); // Handle successful response here
            })
            .catch(error => {
                console.log(error.response ? error.response.data : error.message); // Handle error here
            });
        }
    };

    const translationOptions = [
        { id: "translit", label: "Enable" },
        { id: "asdTranslate", label: "Mohammad Asad" , toggleFunc: toggleAsdTranslate},
        { id: "malikTranslate", label: "Muhammad Farooq-i-Azam Malik" , toggleFunc: toggleMalTranslate},
        { id: "mustafaTranslate", label: "Mustafa Khattab", toggleFunc: toggleMktTranslate},
        { id: "piktcalTranslate", label: "Pickthall", toggleFunc: togglePikTranslate},
        { id: "yusufTranslate", label: "Abdullah Yusuf Ali", toggleFunc: toggleYatTranslate }
    ];

    useEffect(()=>{
        if(typeof translationSettings==="object")
        {
            translationSettingsStore.set(translationSettings);
            checkAllTranslationStatus();
            initTranslationCards();
            if(isInitiated)
            {
                updateCloudTransSettings();
            }
        }
    },[translationSettings]);

    useEffect(() => {
        const unsubscribe = translationSettingsStore.subscribe(setTranslationSettings);
        return () => unsubscribe(); // Cleanup on unmount
    }, []);

    return(
        <>
            <ul className="p-3 text-sm space-y-3" aria-labelledby="dropdownDividerButton">
                {
                    translationOptions
                    .filter(option => option.id !== "translit") // Exclude Transliteration
                    .map(option => (
                        <li key={option.id}>
                            <div className="flex items-center">
                            <input
                                id={`translation-item-${option.id}`}
                                type="checkbox"
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                                onChange={option.toggleFunc}
                                checked={translationSettings[option.id]}
                            />
                            <label
                                htmlFor={`translation-item-${option.id}`}
                                className="ml-2 text-sm font-medium text-white"
                            >
                                {option.label}
                            </label>
                            </div>
                        </li>
                    ))
                }
            </ul>
            <ul className="p-3 text-sm space-y-3">
                <li>
                    <div className="flex items-center">
                        <input
                            id="translation-item-1"
                            type="checkbox"
                            className={"w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500 chkTranslit"}
                            onChange={toggleTransliteration}
                            checked={translationSettings.translit}
                        />
                        <label
                            htmlFor="translation-item-1"
                            className="ml-2 text-sm font-medium text-white"
                        >
                            Transliteration
                        </label>
                    </div>
                </li>
            </ul>
        </>
    );
}

export default TranslationMenu;